import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable, map, of } from 'rxjs';
import { Page } from '../../models/page.model';
import { PagedResult } from '../../models/pagedResult.model';
import { PageParentStatus } from '../../models/pageParentStatus.model';

@Injectable({
  providedIn: 'root'
})
export class PageService {

  constructor(private http: HttpClient, private apiService: ApiService) { }

  apiUrl = `${this.apiService.apiUrl}/pages`;

  getPages(pageIndex: number, pageSize: number, search: string): Observable<PagedResult<Page>> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('search', search);

    return this.http.get<PagedResult<Page>>(this.apiUrl, { params });
  }
  getAllPages(): Observable<Page[]> {
    return this.http.get<Page[]>(`${this.apiUrl}/all`);
  }
  getAvailableParentPages(pageId: string): Observable<PageParentStatus> {
    return this.http.get<PageParentStatus>(`${this.apiUrl}/${pageId}/available`);
  }

  getPageDetails(pageId: string): Observable<Page> {
    return this.http.get<Page>(`${this.apiUrl}/${pageId}`).pipe(
      map((page: Page) => {
        return page;
      })
    );
  }

  getPageHistory(pageId: string): Observable<Page[]> {
    return this.http.get<Page[]>(`${this.apiUrl}/${pageId}/history`);
  }

  getExternalPage(pageId: string): Observable<Page|null> {
    return this.http.get<Page|null>(`${this.apiUrl}/${pageId}/external`);
  }

  createPage(page: Page): Observable<Page> {
    return this.http.post<Page>(`${this.apiUrl}`, page);
  }

  updatePage(pageId: string, page: FormData): Observable<Page> {
    return this.http.patch<Page>(`${this.apiUrl}/${pageId}`, page);
  }

  deletePage(pageId: string): Observable<Page> {
    return this.http.delete<Page>(`${this.apiUrl}/${pageId}`);
  }
}
